export const isCmsPages = () => {
  return window.location.pathname.startsWith('/pages');
};
